import { errorEnvelopeSchema, type ErrorEnvelope } from '@fois-utsavvoice/shared';

export class ApiError extends Error {
  readonly status: number;
  readonly envelope: ErrorEnvelope | undefined;

  constructor(status: number, message: string, envelope?: ErrorEnvelope) {
    super(message);
    this.name = 'ApiError';
    this.status = status;
    this.envelope = envelope;
  }
}

function apiBaseUrl(): string {
  const configured = import.meta.env.VITE_API_BASE_URL;
  return configured?.replace(/\/$/, '') ?? '';
}

export async function apiRequest<T>(
  path: string,
  options: RequestInit & { accessToken?: string } = {},
): Promise<T> {
  const headers = new Headers(options.headers);
  headers.set('accept', 'application/json');
  if (options.body && !headers.has('content-type')) {
    headers.set('content-type', 'application/json');
  }
  if (options.accessToken) {
    headers.set('authorization', `Bearer ${options.accessToken}`);
  }

  const response = await fetch(`${apiBaseUrl()}${path}`, {
    ...options,
    headers,
  });

  const text = await response.text();
  const parsed = text ? (JSON.parse(text) as unknown) : undefined;

  if (!response.ok) {
    const envelope = errorEnvelopeSchema.safeParse(parsed);
    throw new ApiError(
      response.status,
      envelope.success ? envelope.data.error.message : 'The request could not be completed.',
      envelope.success ? envelope.data : undefined,
    );
  }

  return parsed as T;
}
